import { render } from "./TheSideBar.vue?vue&type=template&id=b341dbd4"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__